import { useContext } from "react"
import { EditorToolbarButton, EditorToolbarTray } from "./EditorToolbarUI";

import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const EditorListTray = ({context}) => {
    const { editor, editorState } = useContext(context);

    return (
        <EditorToolbarTray>
            <EditorToolbarButton
                icon={<MaterialIcon name='format_list_bulleted' weight={300}/>}
                onClick={() => editor.commands.toggleBulletList()}
                active={editorState.currentList === 'bulleted'}
            />
            <EditorToolbarButton
                icon={<MaterialIcon name='format_list_numbered' weight={300}/>}
                onClick={() => editor.commands.toggleOrderedList()}
                active={editorState.currentList === 'ordered'}
            />
        </EditorToolbarTray>
    )
}





                    